import React, { useState } from 'react';
import { Lock, User, Eye, EyeOff, Shield } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const AdminLogin = ({ showNotification }) => {
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // Add a slight delay for better UX
    setTimeout(() => {
      const result = login(formData.username, formData.password);

      if (result.success) {
        showNotification(result.message, 'success');
        setFormData({ username: '', password: '' });
      } else {
        showNotification(result.message, 'error');
      }

      setLoading(false);
    }, 500);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <Shield size={48} className="admin-login-icon" />
          <h2 className="admin-login-title">Admin Login</h2>
          <p className="admin-login-subtitle">
            Enter your credentials to access the admin panel
          </p>
        </div>

        <form onSubmit={handleSubmit} className="admin-login-form">
          <div className="form-group">
            <label className="form-label">
              <User size={16} />
              Username
            </label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="Enter username"
              className="form-input"
              required
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label className="form-label">
              <Lock size={16} />
              Password
            </label>
            <div className="password-input-container">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter password"
                className="form-input"
                required
                autoComplete="current-password"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="password-toggle"
              >
                {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading || !formData.username || !formData.password}
            className="btn btn-primary admin-login-submit"
          >
            {loading ? (
              <>
                <div className="spinner"></div>
                Logging in...
              </>
            ) : (
              <>
                <Lock size={16} />
                Login
              </>
            )}
          </button>
        </form>

        <div className="admin-login-help">
          <p className="admin-login-note">
            🔐 This is a secure admin area. Only authorized personnel should access this section.
          </p>
          <p className="admin-login-credentials">
            <strong>Default credentials:</strong><br />
            Username: admin<br />
            Password: kogk2024
          </p>
          <p className="admin-login-warning">
            ⚠️ Please change these credentials for security!
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;